<template>
  <v-container class="mt-4">
    <v-row v-resize="onResize">
      <v-col v-if="!isMd" cols="8" offset> <!--1280px以上もしくは960px未満-->
        <h1
          class="mb-3"
          :class="{ 'text-h6': isMobile, 'text-h5': !isMobile}"
          v-html="$t('submissionConfirmationCreativeSetting.title')"
        ></h1>
        <h3
          class="mb-3"
          :class="{ 'text-h6': isMobile }"
          v-html="$t('submissionConfirmationCreativeSetting.advertiserName') + ' : ' + advertiser.advertiserName"
        ></h3>
      </v-col>
      <v-col v-if="isMd" cols="7" offset><!--960px以上1280px未満-->
        <h1
          class="mb-3"
          :class="{ 'text-h6': isMobile, 'text-h5': !isMobile}"
          v-html="$t('submissionConfirmationCreativeSetting.title')"
        ></h1>
        <h3
          class="mb-3"
          :class="{ 'text-h6': isMobile }"
          v-html="$t('submissionConfirmationCreativeSetting.advertiserName') + ' : ' + advertiser.advertiserName"
        ></h3>
      </v-col>
      <v-col v-if="!isMobile && !isMd" cols="4" class="text-right"><!-- 1280px以上-->
        <v-btn v-if="isCpmMode"
          color="light-blue darken-1 text-white"
          @click="clickCampaignList()"
        >{{$t('submissionConfirmationCreativeSetting.buttonCampaignList')}}</v-btn>
        <v-btn v-else
          color="light-blue darken-1 text-white"
          @click="clickCampaignPeriod()"
        >{{$t('submissionConfirmationCreativeSetting.buttonCampaignPeriod')}}</v-btn>
        <v-btn
          color="light-blue darken-1 text-white"
          @click="clickSubmissionConfirmationCampaignList()"
        >{{$t('submissionConfirmationCreativeSetting.buttonCampaignDeliveryStatus')}}</v-btn>
      </v-col>
      <v-col v-if="!isMobile && isMd" cols="5" class="text-right"><!--960px以上1280px未満-->
        <v-btn v-if="isCpmMode"
          color="light-blue darken-1 text-white"
          @click="clickCampaignList()"
        >{{$t('submissionConfirmationCreativeSetting.buttonCampaignList')}}</v-btn>
        <v-btn v-else
          color="light-blue darken-1 text-white"
          @click="clickCampaignPeriod()"
        >{{$t('submissionConfirmationCreativeSetting.buttonCampaignPeriod')}}</v-btn>
        <v-btn
          color="light-blue darken-1 text-white"
          @click="clickSubmissionConfirmationCampaignList()"
        >{{$t('submissionConfirmationCreativeSetting.buttonCampaignDeliveryStatus')}}</v-btn>
      </v-col>
      <v-col v-if="isMobile" cols="12">
        <v-btn v-if="isCpmMode"
          color="light-blue darken-1 text-white"
          @click="clickCampaignList()"
        >{{$t('submissionConfirmationCreativeSetting.buttonCampaignList')}}</v-btn>
        <v-btn v-else
          color="light-blue darken-1 text-white"
          @click="clickCampaignPeriod()"
        >{{$t('submissionConfirmationCreativeSetting.buttonCampaignPeriod')}}</v-btn>
        <v-btn
          color="light-blue darken-1 text-white"
          @click="clickSubmissionConfirmationCampaignList()"
        >{{$t('submissionConfirmationCreativeSetting.buttonCampaignDeliveryStatus')}}</v-btn>
      </v-col>
      <v-col cols="12" offset v-if="errorMessage">
        <v-alert :value="true" type="error" v-html="$t(errorMessage)"></v-alert>
      </v-col>
    </v-row>
    <v-row v-resize="onResize">
      <v-col md="3" cols="12" offset-xs>
        <div>
          <span class="v-label v-label--active theme--light" style="left: 0px; right: auto; font-size: 12px;">
            {{ $t('commons.filter.calendar.title.createdDateRange') }}
          </span>
          <br />
          <VueDatePicker
            ref="picker"
            :locale="datepickerLocaleString"
            v-model="dateRange"
            :range="true"
            :ranges="ranges"
            :format="formatDisplayDate"
            :enable-time-picker="false"
            :min-date="minDate"
            :max-date="maxDate"
            :auto-apply="false"
            :hide-input-icon="true"
            @closed="handlePickerClosed"
            :multi-calendars="{ solo: true, count: 2, static: false }" 
            close-on-auto-apply="false"
            :clearable="false"
            :month-change-on-scroll="false"
          >
            <template #trigger>
              <div class="custom-input-trigger">
                <div v-if="dateRange && dateRange.length === 2">
                  {{ formatDisplayDate(dateRange) }}
                </div>
                <div v-else style="width:188px;">
                  {{ $t('commons.filter.calendar.placeHolder') }}
                </div>
              </div>
            </template>
            <template #left-sidebar="{ }">
              <div class="dp__sidebar" style="width: 130px;">
                <ul>
                  <li 
                    v-for="(range, name) in ranges" 
                    :key="name" 
                    @click="updateDateRangeFromLabel(range)" class="dp__menu_item"
                  >
                    <b>{{ name }}</b>
                  </li>
                </ul>
              </div>
            </template>
            <template #action-row="{ internalModelValue }">
              <div class="slot" style="display: flex; justify-content: flex-end;">
                <v-btn
                  color="light-green-darken-1"
                  class="text-white"
                  @click="selectPicker(internalModelValue)"
                  :disabled="!isSelectable(internalModelValue)"
                >
                  {{ $t('commons.global.button.select') }}
                </v-btn>
                <v-btn color="light" class="text-black" @click="closePicker()">
                  {{ $t('commons.global.button.cancel') }}
                </v-btn>
              </div>
            </template>
          </VueDatePicker>
        </div>
      </v-col>
      <v-col md="9" cols="12">
        <v-text-field
          v-model="inputCreativeName"
          label="クリエイティブ名"
          variant="underlined"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-resize="onResize">
      <v-col md="3" cols="12">
        <MultiSelect
          v-model:select-items="creativeStatusIds" :items="creativeStatusList"
          item-title="creativeStatusName"
          item-value="creativeStatusId"
          :label="$t('submissionConfirmationCreativeSetting.filter.multiSelect.title.creativeStatus')"
          :no-data-text="$t('commons.form.select.notfound')"
          :rules="[creativeStatusIds && creativeStatusIds.length !== 0 || $t('submissionConfirmationCreativeSetting.filter.multiSelect.noSelection')]" :required="true"
          style="white-space: nowrap;"
          variant="underlined"
        />
      </v-col>
      <v-col md="8" cols="12" offset>
        <v-text-field
          v-model="inputClickUrl"
          label="クリックURL"
          :rules="clickUrlRules"
          variant="underlined"
        ></v-text-field>
      </v-col>
      <v-col md="1" cols="12" class="text-right" offset-xs>
        <v-btn color="blue-grey darken-4 text-white" @click="search()" :disabled=isSearching>{{ $t('commons.global.button.search') }}</v-btn>
      </v-col>
    </v-row>
    <v-row v-resize="onResize">
      <v-col cols="12" class="text-right">
        <v-btn color="light-green darken-1 text-white" @click="clickDownload()" :disabled=isSearching>
          <v-icon>mdi-download</v-icon>
          {{$t('submissionConfirmationCreativeSetting.buttonCsvDownload')}}
        </v-btn>
      </v-col>
    </v-row>
    <v-row justify-center>
      <v-col cols="12">
        <v-data-table
          :headers="submissionConfirmationCreativeSettingHeaders"
          :items="creativeSettingList"
          :hide-default-header="isMobile"
          :no-data-text="$t('commons.table.no.data.text')"
          hide-default-footer
          :sort-by="pagination.sortBy"
          :sortDesc="pagination.descending"
          :items-per-page="pagination.rowsPerPage"
          class="elevation-3 creative-setting-list"
          :class="{mobile: isMobile}"
          :loading="isSearching"
        >
          <template v-slot:header="{ props }">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.key || header.value"
                :class="['column', header.sortable ? 'sortable' : '', 'text-center', pagination.sortBy[0]?.key === (header.key || header.value) ? (pagination.descending ? 'desc' : 'asc') : '']"
                @click="header.sortable && changeSort(header.value)"
              >
                {{ header.title }}
                <v-icon small v-if="header.sortable">mdi-arrow-up</v-icon> </th>
            </tr>
          </template>
          <template v-slot:item="props">
            <tr v-if="!isMobile">
              <td class="table-name-width text-left">{{ props.item.campaignName }}</td>
              <td class="table-status-width text-center">{{ props.item.campaignStatus }}</td>
              <td class="table-name-width text-left">{{ props.item.creativeName }}</td>
              <td v-if="props.item.creativeType==8" class="text-center">
                <img
                  v-bind:src="props.item.thumbnail"
                  style="margin-top:3px; max-width: 120px; max-height: 90px;"
                  v-on:click="previewDialog(props.item.creativeId, props.item.preview, props.item.creativeSize)"
                />
                <br />
                <v-btn
                  style="height:25px; text-transform:capitalize;"
                  color="light-gray darken-1 black--text"
                  v-on:click="previewDialog(props.item.creativeId, props.item.preview, props.item.creativeSize)"
                >{{$t('submissionConfirmationCreativeSetting.buttonPreview')}}</v-btn>
              </td>
              <td v-else-if="props.item.creativeType==10" class="text-center">
                <img
                  v-bind:src="props.item.thumbnail"
                  v-on:click="previewCkickOpenWindow(props.item.creativeId, props.item.preview)"
                  style="margin-top:3px; max-width: 120px; max-height: 90px"
                />
                <br />
                <v-btn
                  style="height:25px; text-transform:capitalize;"
                  color="light-gray darken-1 black--text"
                  v-on:click="previewCkickOpenWindow(props.item.creativeId, props.item.preview)"
                >
                  <v-icon style="height: 20px;font-size:15px;">mdi-open-in-new</v-icon>
                  {{$t('submissionConfirmationCreativeSetting.buttonMoviePlay')}}
                </v-btn>
              </td>
              <td v-else-if="props.item.creativeType==4" class="text-center">
                <img
                  v-on:click="previewDialog(props.item.creativeId, convertDynamicCreative(props.item.preview), props.item.creativeSize)"
                  v-bind:src="props.item.thumbnail"
                  style="margin-top:3px; max-width: 120px; max-height: 90px"
                />
                <br />
                <v-btn
                  style="height:25px; text-transform:capitalize;"
                  color="light-gray darken-1 black--text"
                  v-on:click="previewDialog(props.item.creativeId, convertDynamicCreative(props.item.preview), props.item.creativeSize)"
                >{{$t('submissionConfirmationCreativeSetting.buttonPreview')}}</v-btn>
              </td>
              <td
                v-else-if="props.item.creativeType==5 || props.item.creativeType==6"
                class="text-center"
              >
                <img
                  v-on:click="previewDialog(props.item.creativeId, props.item.preview, '300x350', $t('submissionConfirmationCreativeSetting.dialog.notes'))"
                  v-bind:src="props.item.thumbnail"
                  style="margin-top:3px; max-width: 120px; max-height: 90px"
                />
                <br />
                <v-btn
                  style="height:25px; text-transform:capitalize;"
                  color="light-gray darken-1 black--text"
                  v-on:click="previewDialog(props.item.creativeId, props.item.preview, '300x350', $t('submissionConfirmationCreativeSetting.dialog.notes'))"
                >{{$t('submissionConfirmationCreativeSetting.buttonPreview')}}</v-btn>
              </td>
              <td v-else-if="props.item.creativeType==1" class="text-center">
                <img
                  v-on:click="previewResizeDialog(props.item.creativeId, props.item.preview, props.item.creativeSize)"
                  v-bind:src="props.item.thumbnail"
                  style="margin-top:3px; max-width: 120px; max-height: 90px"
                />
                <br />
                <v-btn
                  style="height:25px; text-transform:capitalize;"
                  color="light-gray darken-1 black--text"
                  v-on:click="previewResizeDialog(props.item.creativeId, props.item.preview, props.item.creativeSize)"
                >{{$t('submissionConfirmationCreativeSetting.buttonPreview')}}</v-btn>
              </td>
              <td v-else-if="props.item.creativeType==13" class="text-center">
                <img
                  v-if="props.item.thumbnail != null"
                  v-on:click="previewResizeDialog(props.item.creativeId, props.item.preview, props.item.creativeSize)"
                  v-bind:src="props.item.thumbnail"
                  style="margin-top:3px; max-width: 120px; max-height: 90px"
                />
                <span v-if="props.item.thumbnail == null">
                  {{ $t('submissionConfirmationCreativeSetting.table.thumbnailInPreparation') }}
                </span>
                <br />
                <v-btn
                  style="height:25px; text-transform:capitalize;"
                  color="light-gray darken-1 black--text"
                  v-on:click="previewResizeDialog(props.item.creativeId, props.item.preview, props.item.creativeSize)"
                >{{$t('submissionConfirmationCreativeSetting.buttonPreview')}}</v-btn>
              </td>
              <td v-else class="text-center">
                <img
                  v-on:click="previewDialog(props.item.creativeId, props.item.preview, props.item.creativeSize)"
                  v-bind:src="props.item.thumbnail"
                  style="margin-top:3px; max-width: 120px; max-height: 90px"
                />
                <br />
                <v-btn
                  style="height:25px; text-transform:capitalize;"
                  color="light-gray darken-1 black--text"
                  v-on:click="previewDialog(props.item.creativeId, props.item.preview, props.item.creativeSize)"
                >{{$t('submissionConfirmationCreativeSetting.buttonPreview')}}</v-btn>
              </td>

              <td
                v-if="props.item.creativeType==3 || props.item.creativeType==4 || props.item.creativeType==6 || props.item.creativeType==13"
                class="text-center"
              >-</td>
              <td v-else class="table-name-width text-left">{{ props.item.clickUrl }}</td>
              <td
                class="text-center"
              >{{ props.item.creativeSize }}</td>
              <td class="table-type-width text-center break-word-cell">{{ props.item.creativeTypeName }}</td>
              <td class="text-center break-word-cell">
                <div
                  v-html="getCreativeStartEndAtOnScreen(props.item.creativeStartAt, props.item.creativeEndAt, props.item.creativeStartAt2, props.item.creativeEndAt2)"
                ></div>
              </td>
              <td
                style="min-width:120px"
                class="text-center break-word-cell"
              >{{ props.item.creativeCreatedAt ? props.item.creativeCreatedAt.slice(0, 10) : '-' }}</td>
              <td class="table-status1-width text-center">{{ props.item.creativeStatus }}</td>
              <td class="table-status2-width text-center">{{ props.item.landingStatus }}</td>
            </tr>
            <tr v-else>
              <!-- <v-row align="center" justify-center>
                <v-col cols="12"> -->
                  <td>
                    <ul class="flex-content">
                      <li
                        class="flex-item"
                        :data-label="$t('submissionConfirmationCreativeSetting.headers.campaignName')"
                      >{{ props.item.campaignName }}</li>
                      <li
                        class="flex-item"
                        :data-label="$t('submissionConfirmationCreativeSetting.headers.sp.campaignStatus')"
                      >{{ props.item.campaignStatus }}</li>
                      <li
                        class="flex-item"
                        :data-label="$t('submissionConfirmationCreativeSetting.headers.creativeName')"
                      >{{ props.item.creativeName }}</li>
                      <li v-if="props.item.creativeType==13" class="flex-item" :data-label="$t('submissionConfirmationCreativeSetting.headers.thumbnail')">
                        <span v-if="props.item.thumbnail == null">
                          {{ $t('submissionConfirmationCreativeSetting.table.thumbnailInPreparation') }}
                        </span>
                        <img v-else
                          v-bind:src="props.item.thumbnail"
                          style="margin-top:3px; max-width: 120px; max-height: 90px"
                        />
                      </li>
                      <li v-else class="flex-item" :data-label="$t('submissionConfirmationCreativeSetting.headers.thumbnail')">
                        <img
                          v-bind:src="props.item.thumbnail"
                          style="margin-top:3px; max-width: 120px; max-height: 90px"
                        />
                      </li>
                      <li
                        v-if="props.item.creativeType==3 || props.item.creativeType==4 || props.item.creativeType==6 || props.item.creativeType==13"
                        class="flex-item"
                        :data-label="$t('submissionConfirmationCreativeSetting.headers.clickUrl')"
                      >-</li>
                      <li
                        v-else
                        class="flex-item"
                        :data-label="$t('submissionConfirmationCreativeSetting.headers.clickUrl')"
                      >{{ props.item.clickUrl }}</li>
                      <li
                        class="flex-item"
                        :data-label="$t('submissionConfirmationCreativeSetting.headers.creativeSize')"
                      >{{ props.item.creativeSize }}</li>
                      <li
                        class="flex-item"
                        :data-label="$t('submissionConfirmationCreativeSetting.headers.creativeTypeName')"
                      >{{ props.item.creativeTypeName }}</li>
                      <li
                        class="flex-item"
                        :data-label="$t('submissionConfirmationCreativeSetting.headers.creativeStartEnd')"
                      >
                        <div
                          v-html="getCreativeStartEndAtOnScreen(props.item.creativeStartAt, props.item.creativeEndAt, props.item.creativeStartAt2, props.item.creativeEndAt2)"
                        ></div>
                      </li>
                      <li
                        class="flex-item"
                        :data-label="$t('submissionConfirmationCreativeSetting.headers.createdAt')"
                      >{{ props.item.creativeCreatedAt.slice(0, 10) }}</li>
                      <li
                        class="flex-item"
                        :data-label="$t('submissionConfirmationCreativeSetting.headers.sp.creativeStatus')"
                      >{{ props.item.creativeStatus }}</li>
                      <li
                        class="flex-item"
                        :data-label="$t('submissionConfirmationCreativeSetting.headers.sp.landingStatus')"
                      >{{ props.item.landingStatus }}</li>
                    </ul>
                  </td>
                <!-- </v-col>
              </v-row> -->
            </tr>
          </template>
        </v-data-table>
        <div class="preview-pos" v-show="hoverDialogFlag">
          <v-dialog v-model="dialog" :max-width="`${dialogWidth}`">
            <v-card>
              <v-card-actions>
                <div v-html="`${previewImage}`"></div>
              </v-card-actions>
              <v-card-text v-if="description !== ''">
                <span v-html="`${description}`"></span>
              </v-card-text>
              <v-col cols="12" class="text-right">
                <v-btn color="green darken-1" text @click.native="dialog = false">Close</v-btn>
              </v-col>
            </v-card>
          </v-dialog>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="nodataDialog" scrollable max-width="300px">
      <v-card>
        <v-card-title>エラー</v-card-title>
        <v-divider></v-divider>
        <v-card-text height="300px">出力対象がありませんでした</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="nodataDialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="warnDlg.isOpen" persistent :max-width="warnDlg.maxWidth">
      <v-card justify="center">
        <v-card-title>
          <v-icon>mdi-alert</v-icon>
          {{ warnDlg.headline }}
        </v-card-title>
        <v-card-text>
          <div style="margin-left: 10px">{{ warnDlg.msg }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="warnDlg.isOpen = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import CsvDownload from '../plugins/csvDownload'
import Filter from '../plugins/filter'
import moment from 'moment'
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import MultiSelect from './ui/MultiSelect'

export default {
  components: { VueDatePicker, MultiSelect },
  name: 'submissionConfirmationCreativeSetting',
  props: ['advertiserId', 'agencyId'],
  mixins: [CsvDownload, Filter],
  data: function () {
    return {
      nodataDialog: false,
      inputCreativeName: '',
      inputClickUrl: '',
      clickUrlRules: [
        v => /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/.test(v) || '入力値が不正です'
      ],
      dateRange: null,
      opens: 'right',
      ranges: {},
      minDate: null,
      maxDate: null,
      creativeStatusIds: [],
      creativeStatusList: [],
      commiteCreativeName: '',
      commiteClickUrl: '',
      commiteCreativeStatusList: [],
      commiteDateRange: [],
      isSearching: false,
      pagination: {
        sortBy: [{ key: 'campaignName', order:'asc' }],
        descending: false,
        rowsPerPage: -1
      },
      warnDlg: {
        'text-h5': '',
        msg: '',
        maxWidth: 300,
        isOpen: false
      },
      submissionConfirmationCreativeSettingHeaders: [
        {
          title: this.$t('submissionConfirmationCreativeSetting.headers.campaignName'),
          align: 'center',
          key: 'campaignName',
          sortable: true
        },
        {
          title: this.$t('submissionConfirmationCreativeSetting.headers.campaignStatus'),
          align: 'center',
          key: 'campaignStatus',
          class: 'px-1',
          sortable: true,
        },
        {
          title: this.$t('submissionConfirmationCreativeSetting.headers.creativeName'),
          align: 'center',
          key: 'creativeName',
          sortable: true,
        },
        {
          title: this.$t('submissionConfirmationCreativeSetting.headers.thumbnail'),
          align: 'center',
          key: 'thumbnail',
          sortable: false,
        },
        {
          title: this.$t('submissionConfirmationCreativeSetting.headers.clickUrl'),
          align: 'center',
          key: 'clickUrl',
          sortable: true,
        },
        {
          title: this.$t('submissionConfirmationCreativeSetting.headers.creativeSize'),
          align: 'center',
          key: 'creativeSize',
          sortable: false,
        },
        {
          title: this.$t('submissionConfirmationCreativeSetting.headers.creativeTypeName'),
          align: 'center',
          key: 'creativeTypeName',
          sortable: false,
        },
        {
          title: this.$t('submissionConfirmationCreativeSetting.headers.creativeStartEnd'),
          align: 'center',
          key: 'deliveryStartEnd1',
          sortable: false,
        },
        {
          title: this.$t('submissionConfirmationCreativeSetting.headers.createdAt'),
          align: 'center',
          key: 'creativeCreatedAt',
          sortable: true,
        },
        {
          title: this.$t('submissionConfirmationCreativeSetting.headers.creativeStatus'),
          align: 'center',
          key: 'creativeStatus',
          class: 'px-1',
          sortable: true,
        },
        {
          title: this.$t('submissionConfirmationCreativeSetting.headers.landingStatus'),
          align: 'center',
          key: 'landingStatus',
          class: 'px-1',
          sortable: true,
        }
      ],
      advertiser: {},
      creativeSettingList: [],
      privateCode: process.env.ProjectCode,
      isMobile: false,
      isMd: false,
      isCpmMode: false,
      errorMessage: undefined,
      preview: '',
      hoverFlag: false,
      charactorHoverFlag: false,
      hoverDialogFlag: false,
      hoverVideoFlag: false,
      hoverIndex: null,
      previewImage: '',
      previewMovie: '',
      description: '',
      dialog: false,
      dialogWidth: 0,
      image_more_src: require(`../../public/imgs/outline_search_black_18dp.png`),
      picker: null,
      todayDate: null
    }
  },
  methods: {
    ...mapActions('creativeSetting', ['getFilterList', 'getCreativeSettingList']),
    handlePickerClosed: function () {
      // commitedateRangeはhandlePickerUpdateで更新されているので、dateRangeをそれに合わせる
      if (this.commitedateRange[0] && this.commitedateRange[1]) {
        this.dateRange = [...this.commitedateRange];
      } else {
        this.dateRange = null;
      }
    },

    selectPicker: function (internalModelValue) {
      if (this.$refs.picker) {
        if (internalModelValue) {
          this.dateRange = internalModelValue;
          this.commitedateRange = internalModelValue;
        } else {
          this.dateRange = null;
          this.commitedateRange = [null, null];
        }
        this.$refs.picker.closeMenu();
      }
      
    },

    closePicker: function () {
      if (this.commitedateRange[0] && this.commitedateRange[1]) {
        this.dateRange = [...this.commitedateRange];
      } else {
        this.dateRange = null;
      }
      
      this.$refs.picker.closeMenu();
    },

    updateDateRangeFromLabel: function(range) {
      if (range && range.length === 2) {
        if (range[0] == null && range[1] == null) {
          this.dateRange = null
          this.commiteDateRange = [...range];
        } else {
          this.dateRange = [...range];
          this.commiteDateRange = [...range];
        }
      } else {
        // ここに来ることはないはずだが、一応
        this.dateRange = null;
        this.commiteDateRange = [null, null];
      }
    },
    initialize: function () {
      this.initializeDateTimeRanges()
      this.syncQuery()
      if (this.$route.query.campaignIds !== undefined) {
        this.campaignIds = this.$route.query.campaignIds
      } else {
        this.campaignIds = undefined
      }
      this.initializeFilter().then((flg) => {
        if (flg) {
          this.previewCreativeSettingList()
        }
      })
    },
    initializeDateTimeRanges: function () {
      // 今日
      const today = moment().startOf('day').toDate()
      // 昨日
      const yesterday = moment(today).add(-1, 'days').startOf('day').toDate()
      // 当日から一週間前
      const lastWeekAgo = moment(today).add(-6, 'days').toDate()
      // 昨日から一週間前
      const lastWeekDayAgo = moment(yesterday).add(-6, 'days').toDate()
      // 月初
      const monthFirst = moment(today).startOf('month').toDate()
      // 先月末
      const lastMonthEnd = moment(today).startOf('month').add(-1, 'days').toDate()
      // 先月月初
      const lastMonthFirst = moment(lastMonthEnd).startOf('month').toDate()
      // 30日前
      const day30ago = moment(today).add(-29, 'days').toDate()
      // 半年前（厳密な半年ではないが、代理店画面と合わせた）
      const halfYearDay = moment(today).add(-6, 'month').add(1, 'days').toDate()
      this.ranges = {
        [this.$t('commons.filter.calendar.all')]: [null, null],
        [this.$t('commons.filter.calendar.today')]: [today, today],
        [this.$t('commons.filter.calendar.yesterday')]: [yesterday, yesterday],
        [this.$t('commons.filter.calendar.lastWeekAgo')]: [lastWeekAgo, today],
        [this.$t('commons.filter.calendar.lastWeekDayAgo')]: [lastWeekDayAgo, yesterday],
        [this.$t('commons.filter.calendar.day30ago')]: [day30ago, today],
        [this.$t('commons.filter.calendar.halfYearDay')]: [halfYearDay, today],
        [this.$t('commons.filter.calendar.thisMonth')]: [monthFirst, today],
        [this.$t('commons.filter.calendar.thisMonthYesterday')]: [monthFirst, yesterday],
        [this.$t('commons.filter.calendar.lastMonth')]: [lastMonthFirst, lastMonthEnd]
      }
      this.maxDate = today
      // 代理店画面と合わせて半年前の1日まで選択可能とした
      this.minDate = null
      this.dateRange = null
      this.commitedateRange = [null, null]
    },
    // フィルター部分の初期化処理
    initializeFilter: async function () {
      const jwtToken = this.$store.getters['auth/jwtToken']
      const agencyId = this.agencyId
      const advertiserId = this.advertiserId
      let flg = false

      // URLにパラメータを付与
      var url = location.href
      if (url.indexOf('?') !== -1) {
        url = url.substring(0, url.indexOf('?'))
      }
      // 後続処理でレポートを取得したいのでこの処理が終わるまで後続処理を待つ
      await this.getFilterList({
        privateCode: process.env.ProjectCode,
        agencyId: agencyId,
        advertiserId: advertiserId,
        jwtToken: jwtToken
      })
        .then((result) => {
          this.errorMessage = undefined
          if (!result) {
            // 表示するデータがない場合
            this.creativeStatusList = []
            return flg
          }
          // Select ボックスの初期値を設定
          this.creativeStatusList = result.creativeStatusList
          // フィルターの初期選択状態をハンドリングする
          this.setInitializeParameter()
          // キャンペーンは選択必須のため初期選択されていなければ後続処理は行わない
          if (this.commiteCreativeStatusList.length > 0) {
            flg = true
          }
        })
        .catch((err) => {
          if (err instanceof ReferenceError) {
            this.errorMessage = err.message
          } else {
            // idToken が切れているのでセッションを切り、ログイン画面に遷移する
            this.$store.dispatch('auth/logout')
            this.$router.go({ path: this.$router.currentRoute.path, force: true })
          }
        })
      return flg
    },
    previewCreativeSettingList: function () {
      this.isSearching = true
      const jwtToken = this.$store.getters['auth/jwtToken']
      const agencyId = this.agencyId
      const advertiserId = this.advertiserId
      const campaignIds = this.campaignIds
      const creativeName = this.commiteCreativeName
      const clickUrl = this.commiteClickUrl
      const createdAtFrom = this.commiteDateRange[0] ? this.formatParameterDate(this.commiteDateRange[0]) : null
      const createdAtTo = this.commiteDateRange[1] ? this.formatParameterDate(this.commiteDateRange[1]) : null
      const creativeStatus = this.createParameter(this.commiteCreativeStatusList, this.creativeStatusList)

      // URLにパラメータを付与
      var url = location.href
      if (url.indexOf('?') !== -1) {
        url = url.substring(0, url.indexOf('?'))
      }
      this.getCreativeSettingList({
        privateCode: process.env.ProjectCode,
        agencyId: agencyId,
        advertiserId: advertiserId,
        campaignIds: campaignIds,
        creativeName: creativeName,
        clickUrl: clickUrl,
        createdAtFrom: createdAtFrom,
        createdAtTo: createdAtTo,
        creativeStatus: creativeStatus,
        jwtToken: jwtToken
      })
        .then((result) => {
          this.errorMessage = undefined
          if (!result) {
            // 表示するデータがない場合
            this.creativeSettingList = []
            this.advertiser = {}
            return
          }
          this.advertiser = result.advertiser
          this.creativeSettingList = result.creativeSettingList
          this.createUrlParameter()
        })
        .catch((err) => {
          if (err instanceof ReferenceError) {
            this.errorMessage = err.message
          } else {
            // idToken が切れているのでセッションを切り、ログイン画面に遷移する
            this.$store.dispatch('auth/logout')
            this.$router.go({ path: this.$router.currentRoute.path, force: true })
          }
        })
        .then(() => {
          this.isSearching = false
        })
    },
    syncQuery: function() {
      let queryDict = this.$route.query
      const cName = queryDict['cName']
      const cURL = queryDict['cURL']
      const cStatus = queryDict['cStatus']
      const fromStr = queryDict['from']
      const toStr = queryDict['to']

      if (cName) {
        // クエリからのクリエイティブ名を画面 Input と検索用パラメータに反映する
        this.inputCreativeName = cName
        this.commiteCreativeName = cName
      }
      if (cURL && this.checkUrlCharacter(cURL)) {
        // クエリからのクリエイティブ URL を画面 Input と検索用パラメータに反映する
        this.inputClickUrl = cURL
        this.commiteClickUrl = cURL
      }
      if (cStatus && this.checkStatusCharacter(cStatus)) {
        // クエリからのクリエイティブステータスを画面 Multiselect と検索用パラメータに反映する
        this.creativeStatusIdsComputed = [parseInt(cStatus)]
        this.commiteCreativeStatusList = [parseInt(cStatus)]
      }
      if (fromStr && toStr) {
        // クエリからの日付の文字列の YYYYMMDD フォーマットチェック
        if (this.isYYYYMMDD(fromStr) && this.isYYYYMMDD(toStr)) {
          // momentオブジェクトに変換してdateRangeとcommitedateRangeを更新
          this.dateRange = [moment(fromStr, 'YYYYMMDD').toDate(), moment(toStr, 'YYYYMMDD').toDate()]
          this.commiteDateRange = [moment(fromStr, 'YYYYMMDD').toDate(), moment(toStr, 'YYYYMMDD').toDate()]
        }
      } else { // 'all'や日付が指定されていない場合、null, nullに設定
          this.dateRange = null
          this.commiteDateRange = [ null, null ]
      }
    },
    // クリエイティブステータス文字列（0 or 1）のチェック
    checkStatusCharacter: function(str) {
      return /^[0-1]$/.test(str)
    },
    // 文字列の YYYYMMDD フォーマットチェック
    isYYYYMMDD: function(dateStr) {
      // 8(YYYYMMDD) 文字でない場合 false
      if (dateStr.length !== 8) {
        return false
      }
      // 年、月、日を取得する
      const year = parseInt(dateStr.substr(0, 4))
      const month = parseInt(dateStr.substr(4, 2)) - 1 // 月は0～11で指定するため-1しています。
      const day = parseInt(dateStr.substr(6, 2))
      const date = new Date(year, month, day)
      return (year === date.getFullYear() && month === date.getMonth() && day === date.getDate())
    },
    createUrlParameter: function () {
      const newQuery = {};

      // クリエイティブ名
      if (this.commiteCreativeName) {
        newQuery.cName = this.commiteCreativeName;
      } else {
        newQuery.cName = undefined;
      }

      // クリックURL
      if (this.commiteClickUrl && this.checkUrlCharacter(this.commiteClickUrl)) {
        newQuery.cURL = this.commiteClickUrl;
      } else {
        newQuery.cURL = undefined;
      }

      // クリエイティブステータス
      if (this.commiteCreativeStatusList && this.commiteCreativeStatusList.length > 0 && Object.keys(this.creativeStatusList).length !== this.commiteCreativeStatusList.length) {
        newQuery.cStatus = this.commiteCreativeStatusList.join(',');
      } else {
        newQuery.cStatus = undefined;
      }

      // 登録日
      if (this.dateRange && this.dateRange.length === 2 && this.dateRange[0] && this.dateRange[1]) {
        newQuery.from = this.formatParameterDate(this.dateRange[0]);
        newQuery.to = this.formatParameterDate(this.dateRange[1]);
      } else {
        newQuery.from = undefined;
        newQuery.to = undefined;
      }

      const currentQuery = { ...this.$route.query };
      
      this.$router.replace({
        path: this.$route.path,
        query: { ...currentQuery, ...newQuery }
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Router replace error:', err);
        }
      });
    },
    search: function () {
      if (this.creativeStatusIdsComputed.length === 0) {
        this.warnDialog('確認', '条件が指定されていません')
        return
      }
      this.commiteCreativeName = this.inputCreativeName
      this.commiteClickUrl = this.inputClickUrl
      this.commiteCreativeStatusList = this.creativeStatusIdsComputed
      if (this.dateRange === null) {
        this.commiteDateRange = [null, null]
      } else {
        this.commiteDateRange = [...this.dateRange]
      }

      this.previewCreativeSettingList()
    },
    clickDownload: function () {
      this.isDownloadCsv = true
      const creativeSettingList = this.$store.getters['creativeSetting/creativeSettingList']
      if (!creativeSettingList || creativeSettingList.length <= 0) {
        this.nodataDialog = true
        this.isDownloadCsv = false
        return
      }
      let csvList = []
      csvList.push(this.getCsvTitle())
      creativeSettingList.forEach((el) => {
        let line = ''
        let creativeStartEndAt = this.getCreativeStartEndAtCsv(el['creativeStartAt'], el['creativeEndAt'])
        let creativeStartEndAt2 = this.getCreativeStartEndAtCsv(el['creativeStartAt2'], el['creativeEndAt2'])
        let creativeSize = el['creativeSize']
        let clickUrl = this.getClickUrl(el['creativeType'], el['clickUrl'])
        if (el['thumbnailType'] === 2 && el['creativeType'] !== 10) {
          // VideoAds 以外の SSServer から取得したサムネイルPATHは空文字設定にする
          line = `${this.advertiser.advertiserName},${this.getReplaceEscapeCharactor(el['campaignName'])},${
            el['campaignStatus']
          },${this.getReplaceEscapeCharactor(el['creativeName'])},${this.$t(
            'submissionConfirmationCreativeSetting.csv.value.SSSeverThumbnail'
          )},${this.getReplaceEscapeCharactor(el['preview'])},${this.getReplaceEscapeCharactor(clickUrl)},${creativeSize},${
            el['creativeTypeName']
          },${creativeStartEndAt},${creativeStartEndAt2},${el['creativeCreatedAt']},${el['creativeStatus']},${
            el['landingStatus']
          },${this.getReplaceEscapeCharactor(el['landingUrl'])}`
        } else {
          line = `${this.advertiser.advertiserName},${this.getReplaceEscapeCharactor(el['campaignName'])},${
            el['campaignStatus']
          },${this.getReplaceEscapeCharactor(el['creativeName'])},${this.getReplaceEscapeCharactor(el['thumbnail'])},${this.getReplaceEscapeCharactor(
            el['preview']
          )},${this.getReplaceEscapeCharactor(clickUrl)},${creativeSize},${el['creativeTypeName']},${creativeStartEndAt},${creativeStartEndAt2},${
            el['creativeCreatedAt']
          },${el['creativeStatus']},${el['landingStatus']},${this.getReplaceEscapeCharactor(el['landingUrl'])}`
        }
        csvList.push(line)
      })
      this.csvDownload(csvList, 'confirmation_creative', [this.agencyId, this.advertiser.advertiserId])
      this.isDownloadCsv = false
    },
    createParameter(params, list) {
      if (Object.keys(list).length !== params.length) {
        return params.join(',')
      }
    },
    getReplaceEscapeCharactor: function (str) {
      let strValue = str.replace(/\r?\n/g, ' ')
      let tagValue = strValue.replace(/\t/g, ' ')
      let replaceValue = tagValue.replace(/\"/g, '""')
      return '"' + replaceValue + '"'
    },
    checkUrlCharacter: function (str) {
      return /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/.test(str)
    },
    getCsvTitle: function () {
      return (
        this.$t('advertiser.headers.advertiserName') +
        ',' +
        this.$t('submissionConfirmationCreativeSetting.csv.headers.campaignName') +
        ',' +
        this.$t('submissionConfirmationCreativeSetting.csv.headers.campaignStatus') +
        ',' +
        this.$t('submissionConfirmationCreativeSetting.csv.headers.creativeName') +
        ',' +
        this.$t('submissionConfirmationCreativeSetting.csv.headers.thumbnail') +
        ',' +
        this.$t('submissionConfirmationCreativeSetting.csv.headers.preview') +
        ',' +
        this.$t('submissionConfirmationCreativeSetting.csv.headers.clickUrl') +
        ',' +
        this.$t('submissionConfirmationCreativeSetting.csv.headers.creativeSize') +
        ',' +
        this.$t('submissionConfirmationCreativeSetting.csv.headers.creativeTypeName') +
        ',' +
        this.$t('submissionConfirmationCreativeSetting.csv.headers.creativeStartEnd1') +
        ',' +
        this.$t('submissionConfirmationCreativeSetting.csv.headers.creativeStartEnd2') +
        ',' +
        this.$t('submissionConfirmationCreativeSetting.csv.headers.createdAt') +
        ',' +
        this.$t('submissionConfirmationCreativeSetting.csv.headers.creativeStatus') +
        ',' +
        this.$t('submissionConfirmationCreativeSetting.csv.headers.landingStatus') +
        ',' +
        this.$t('submissionConfirmationCreativeSetting.csv.headers.landingUrl')
      )
    },
    changeSort(sortable, column) {
      if (sortable === false) {
        return
      }
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    onResize: function () {
      if (window.innerWidth < 960) {
        this.isMobile = true
        this.isMd = false
      } else if (window.innerWidth >= 960 && window.innerWidth < 1280) {
        this.isMobile = false
        this.isMd = true
      }else {
        this.isMobile = false
        this.isMd = false
      }
    },
    formatDisplayDate(value) {
      return `${this.formatDate(value[0], 'YYYY/MM/DD')} - ${this.formatDate(value[1], 'YYYY/MM/DD')}`
    },
    formatParameterDate(value) {
      return this.formatDate(value, 'YYYYMMDD')
    },
    formatDate(value, format) {
      return moment(value).format(format)
    },
     isSelectable(dateRange) {
      // 1. dateRangeがnullの場合は、有効とみなす（「すべて」）
      if (dateRange === null) {
        return true;
      }

      // 2. dateRangeが配列で、[null, null]の場合は無効とみなす(commitDateRangeが[null, null]はあり得るが、dateRangeがnullになる)
      if (Array.isArray(dateRange) && dateRange.length === 2 && dateRange[0] === null && dateRange[1] === null) {
        return false;
      }

      // 3. 開始日と終了日が両方とも有効なDateオブジェクトの場合は有効
      if (dateRange && dateRange.length === 2) {
        const [start, end] = dateRange;
        if (start instanceof Date && !isNaN(start) && end instanceof Date && !isNaN(end)) {
          return true;
        }
      }

      // 4. その他の場合は無効（例：片方の日付しか選択されていない状態）
      return false;
    },
    previewDialog: function (index, previewImage, creativeSize, description) {
      this.hoverDialogFlag = true
      this.hoverIndex = index
      this.previewImage = previewImage
      this.dialog = true
      let size = creativeSize.split('x')
      let widthNumber = Number(size[0]) + 20
      this.dialogWidth = String(widthNumber)
      this.description = description !== undefined ? description : ''
    },
    previewResizeDialog: function (index, previewImage, creativeSize) {
      this.description = ''
      this.hoverDialogFlag = true
      this.hoverIndex = index
      this.previewImage = previewImage
      this.dialog = true
      let size = creativeSize.split('x')
      let w = Number(size[0])
      let h = Number(size[1])
      let maxWidth = 1024
      let maxHeight = 600
      if (w > h) {
        if (w > maxWidth) {
          h = (maxWidth * h) / w
          w = maxWidth
        }
      } else {
        if (h > maxHeight) {
          w = (maxHeight * w) / h
          h = maxHeight
        }
      }

      let widthNumber = Number(w) + 20
      this.dialogWidth = String(widthNumber)
    },
    setInitializeParameter: function () {
      this.initializeCreativeStatus()
    },
    initializeCreativeStatus: function () {
      let cIds = []
      if (this.creativeStatusIdsComputed.length > 0) {
        cIds = this.creativeStatusIdsComputed
      } else {
        cIds = this.$route.query.cIds ? String(this.$route.query.cIds).split(',') : null
      }
      if (cIds) {
        let numberIds = []
        cIds.forEach((cId) => {
          numberIds.push(Number(cId))
        })
        this.creativeStatusIdsComputed = numberIds
        this.commiteCreativeStatusList = numberIds
      } else {
        let ids = []
        this.creativeStatusList.forEach(function (item) {
          ids.push(item['creativeStatusId'])
        })
        this.creativeStatusIdsComputed = ids
        this.commiteCreativeStatusList = ids
      }
    },
    previewCkickOpenWindow: function (index, previewMovie) {
      this.hoverVideoFlag = true
      this.hoverIndex = index
      this.previewMovie = previewMovie
      window.open(previewMovie, null)
    },
    convertDynamicCreative: function (scriptTag) {
      // Dynamic クリエイティブのプレビュータグはスクリプトタグで生成されている為、
      // プレビュー時はバックエンド側で生成したiframeタグのみを抽出する
      const previewTagStartPos = 47
      const previewTagEndPos = -12
      return scriptTag.slice(previewTagStartPos, previewTagEndPos)
    },
    getCreativeStartEndAtCsv: function (creativeStartAt, creativeEndAt) {
      if (creativeStartAt === null && creativeEndAt === null) {
        return '指定なし'
      } else if (creativeStartAt === null) {
        return '指定なし - ' + creativeEndAt.slice(0, 16)
      } else if (creativeEndAt === null) {
        return creativeStartAt.slice(0, 16) + ' - 指定なし'
      } else {
        return creativeStartAt.slice(0, 16) + ' - ' + creativeEndAt.slice(0, 16)
      }
    },
    getCreativeStartEndAt: function (creativeStartAt, creativeEndAt) {
      if (creativeStartAt === null && creativeEndAt === null) {
        return '指定なし'
      } else if (creativeStartAt === null) {
        return '指定なし - ' + creativeEndAt.slice(0, 10)
      } else if (creativeEndAt === null) {
        return creativeStartAt.slice(0, 10) + ' - 指定なし'
      } else {
        return creativeStartAt.slice(0, 10) + ' - ' + creativeEndAt.slice(0, 10)
      }
    },
    getCreativeStartEndAtOnScreen: function (creativeStartAt, creativeEndAt, creativeStartAt2, creativeEndAt2) {
      if (creativeStartAt === null && creativeEndAt === null && creativeStartAt2 === null && creativeEndAt2 === null) {
        return '指定なし'
      } else {
        if (creativeStartAt2 === null && creativeEndAt2 === null) {
          return this.getCreativeStartEndAt(creativeStartAt, creativeEndAt)
        } else {
          return this.getCreativeStartEndAt(creativeStartAt, creativeEndAt) + '<br/>' + this.getCreativeStartEndAt(creativeStartAt2, creativeEndAt2)
        }
      }
    },
    getClickUrl: function (creativeType, clickUrl) {
      // タグ、ダイナミック、ネイティブダイナミック、第三者 VAST インバナー動画はクリック URL をハイフンで表記する
      if (creativeType === 3 || creativeType === 4 || creativeType === 6 || creativeType === 13) {
        return '-'
      } else {
        return clickUrl
      }
    },
    clickCampaignPeriod: function () {
      this.$router.push(`/campaignPeriodList/${this.agencyId}/${this.advertiserId}`)
    },
    clickCampaignList: function () {
      this.$router.push(`/campaignList/${this.agencyId}/${this.advertiserId}`)
    },
    clickSubmissionConfirmationCampaignList: function () {
      this.$router.push(`/campaignLanding/counts/${this.agencyId}/${this.advertiserId}`)
    },
    warnDialog: function (title, message) {
      this.warnDlg.headline = title
      this.warnDlg.msg = message
      this.warnDlg.isOpen = true
    }
  },
  mounted: function () {
    if (process.env.ProjectCode === '111') {
      this.isCpmMode = true
    }
    this.initialize()
  },
  computed: {
    datepickerLocaleString() {
      return 'ja';
    },
    creativeStatusIdsComputed: {
      get() {
        return this.creativeStatusIds
      },
      set(value) {
        this.creativeStatusIds = value
      }
    }
  },
  watch: {}
}
</script>
<style scoped>
.creative-setting-list .break-word-cell {
  max-width: 2000px; /* ここは用途に応じて調整 */
  word-wrap: break-word;
  white-space: nowrap; /* 折り返しを有効にするためにnormal */
}
.preview-pos {
  position: fixed;
  top: 40%;
  left: 20%;
  transform: translate(-50%, -50%);

  padding: 15px 30px;
  text-align: center;
  width: 300px;
}
.charactorPreview-pos {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);

  padding: 15px 30px;
  text-align: center;
  width: 400px;
  background-color: #ffffff;
}
/* th:first-child, */
/* table.v-table thead th:not(:first-child) {
  padding: 0 10px;
} */
/* table.v-table tbody td:first-child, */
/* table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 5px;
} */
.table-name-width {
  min-width: 300px;
  width: 300px;
  max-width: 300px;
  word-wrap: break-word;
  word-break: break-all;
}
.table-status-width {
  min-width: 125px;
  width: 125px;
  max-width: 125px;
}
.table-status1-width {
  min-width: 135px;
  width: 135px;
  max-width: 135px;
}
.table-status2-width {
  min-width: 147px;
  width: 147px;
  max-width: 147px;
}
.table-type-width {
  min-width: 125px;
  width: 125px;
  max-width: 125px;
}
.custom-input-trigger {
  border: 1px solid #ccc;
  padding: 8px;
  cursor: pointer;
  max-width: 210px;
}
.v-btn {
  margin: 4px;
}
:deep(.dp__arrow_top) {left: 130px !important;}
:deep(.dp__arrow_bottom) {left: 130px important;}
</style>